import { render, staticRenderFns } from "./MoveDate.vue?vue&type=template&id=60c780b4&"
import script from "./MoveDate.vue?vue&type=script&lang=js&"
export * from "./MoveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports